import { useGSAP } from "@gsap/react"
import gsap from "gsap"
import { rightImg, watchImg } from "../utils"

// import VideoCarousel from './VideoCarousel';

const Highlights = () => {
  useGSAP(() => {
    gsap.to('#title', { opacity: 1, y: 0 })
    gsap.to('.link', { opacity: 1, y: 0, duration: 1, stagger: 0.25 })
  }, [])

  return (
    <section id="highlights" className="w-screen overflow-hidden h-full common-padding bg-slate-100">
      <div className="screen-max-width">
        <div className="mb-12 w-full md:flex items-end justify-between">
        <h1 id="title" className="font-bold text-6xl text text-slate-900">Off-Market
Real Estate
Investing</h1>

      
        </div>

     
      </div>
    </section>
  )
}

export default Highlights